// Helper function to safely parse dates
const parseDate = (dateString) => {
  if (!dateString) return null
  const date = new Date(dateString)
  return isNaN(date.getTime()) ? null : date
}

// Helper function to normalize IDs
const normalizeId = (id) => id?.split('/')?.pop() ?? id

// Helper function to safely check array intersections
const hasIntersection = (arr1 = [], arr2 = [], normalize = false) => {
  if (!Array.isArray(arr1) || !Array.isArray(arr2)) return false
  if (arr1.length === 0 || arr2.length === 0) return false

  // Convert arrays to Sets for O(1) lookup
  const set1 = new Set(normalize ? arr1.map(normalizeId) : arr1)
  return arr2.some((item) => set1.has(normalize ? normalizeId(item) : item))
}

const isLoggedIn = () => {
  return GM_STATE?.customer?.logged
}

const isCorrectUserScope = (scope) => {
  switch (scope) {
    case 'Logged Out Customers':
      return !isLoggedIn()
    case 'Logged In Customers':
      return isLoggedIn()
    default:
      return true
  }
}

export function checkConditions(conditions = {}, criteria = {}) {
  try {
    const { tags = [], productIds = [], collectionIds = [] } = criteria

    if (!conditions?.tags && !conditions?.collections && !conditions?.products) {
      return false
    }

    if (!tags?.length && !collectionIds?.length && !productIds?.length) {
      return false
    }

    const results = {
      hasTags: !conditions?.tags || hasIntersection(conditions.tags, tags),
      hasCollection: !conditions?.collections || hasIntersection(conditions.collections, collectionIds, true),
      hasProduct: !conditions?.products || hasIntersection(conditions.products, productIds),
      hasStarted: true,
      hasNotEnded: true,
      hasCorrectScope: !conditions?.user_scope || isCorrectUserScope(conditions.user_scope),
      hasCorrectContext: !conditions?.display_context || ['Both', 'Website Only'].includes(conditions.display_context)
    }

    // Date checks
    const now = Date.now()
    const startDate = parseDate(conditions?.start_date)
    const endDate = parseDate(conditions?.end_date)

    if (startDate) {
      results.hasStarted = now > startDate.getTime()
    }

    if (endDate) {
      results.hasNotEnded = now < endDate.getTime()
    }

    return Object.values(results).every(Boolean)
  } catch (e) {
    console.warn('Error in checkConditions: ', e)
    return false
  }
}

const asCriteriaList = (value) => {
  if (value == null || value === '') return []
  if (Array.isArray(value)) return value
  return [value]
}

export function checkTargeting(entry = {}, criteria = {}) {
  const tags = asCriteriaList(criteria.tags)
  const productIds = asCriteriaList(criteria.productIds)
  const collectionIds = asCriteriaList(criteria.collectionIds)

  const hasTagConditions = entry?.tags?.length > 0
  const hasProductConditions = entry?.products?.length > 0
  const hasCollectionConditions = entry?.collections?.length > 0

  if (!hasTagConditions && !hasProductConditions && !hasCollectionConditions) {
    return false
  }

  if (hasProductConditions && hasIntersection(entry.products, productIds, true)) return true
  if (hasCollectionConditions && hasIntersection(entry.collections, collectionIds, true)) return true
  if (hasTagConditions && hasIntersection(entry.tags, tags)) return true

  return false
}
